/**
 * Reducers zijn de acties die uitgevoerd worden indien er een state verandering getriggerd wordt.
 * Deze functies zullen er voor zorgen dat de states overschreven worden.
 */

export const FETCH_DATA_ERROR = "FETCH_DATA_ERROR";
export const FETCH_DATA_PENDING = "FETCH_DATA_PENDING";
export const FETCH_FACETS_SUCCESS = "FETCH_FACETS_SUCCESS";
export const FETCH_PAGINATION_SUCCESS = "FETCH_PAGINATION_SUCCESS";
export const FETCH_TEASERS_SUCCESS = "FETCH_TEASERS_SUCCESS";

export const FILTER_BY_CATEGORY = "FILTER_BY_CATEGORY";
export const FILTER_BY_LOCATION = "FILTER_BY_LOCATION";
export const FILTER_BY_PAGE = "FILTER_BY_PAGE";
export const FILTER_BY_REGION = "FILTER_BY_REGION";
export const FILTER_BY_SUBJECT = "FILTER_BY_SUBJECT";
export const FILTER_BY_VALUE = "FILTER_BY_VALUE";

export const LOCATION_VALUE = "LOCATION_VALUE";
export const QUERY_VALUE = "QUERY_VALUE";

export const FACET_FILTERS = "FACET_FILTERS";
export const PAGE_INTRO = "PAGE_INTRO";

export function fetchDataError(error) {
	return {
		type: FETCH_DATA_ERROR,
		payload: error,
	};
}

export function fetchDataPending() {
	return {
		type: FETCH_DATA_PENDING,
	};
}

export function fetchFacetsSuccess(facets) {
	return {
		type: FETCH_FACETS_SUCCESS,
		payload: facets,
	};
}

/**
 * Set Description.
 */
export function fetchPageIntro(data) {
	return {
		type: PAGE_INTRO,
		payload: data,
	};
}

export function fetchPaginationSuccess(totalResults, currentPage, totalPages) {
	return {
		type: FETCH_PAGINATION_SUCCESS,
		payload: {
			totalResults: totalResults,
			currentPage: currentPage,
			totalPages: totalPages,
		},
	};
}

export function fetchTeasersSuccess(teasers) {
	return {
		type: FETCH_TEASERS_SUCCESS,
		payload: teasers,
	};
}

/**
 * ACTIVE FILTERS
 */
export function filterByCategory(data) {
	return {
		type: FILTER_BY_CATEGORY,
		payload: data,
	};
}

export function filterByLocation(data) {
	return {
		type: FILTER_BY_LOCATION,
		payload: data,
	};
}

export function filterByPage(data) {
	return {
		type: FILTER_BY_PAGE,
		payload: data,
	};
}

export function filterByRegion(data) {
	return {
		type: FILTER_BY_REGION,
		payload: data,
	};
}

export function filterBySubject(data) {
	return {
		type: FILTER_BY_SUBJECT,
		payload: data,
	};
}

export function filterByValue(data) {
	return {
		type: FILTER_BY_VALUE,
		payload: data,
	};
}

/**
 * Location value input wordt opgeslagen zodat er gecheckt kan worden
 * of er reeds een location ingevuld werd want met Google Maps Event Listener
 * kan dit naders niet opgeslagen worden.
 */
export function setLocationValue(data) {
	return {
		type: LOCATION_VALUE,
		payload: data,
	};
}

/**
 * Query value wordt ook apart opgeslagen indien er gezocht wordt
 * met een aparte click knop (dus niet met onchange event).
 */
export function setQueryValue(data) {
	return {
		type: QUERY_VALUE,
		payload: data,
	};
}

/**
 * Toggle facet filters
 */
export function showFacetFilters(data) {
	return {
		type: FACET_FILTERS,
		payload: data,
	};
}
